import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Sidebar from "./components/Sidebar";
import TopBalance from "./pages/TopBalance";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Tournaments from "./pages/Tournaments";
import Transactions from "./pages/Transactions";
import Withdraw from "./pages/Withdraw";
import Deposit from "./pages/Deposit";
import TodayScreen from "./pages/todayscreen";
import CreateCS from "./pages/cs_create";
import CsScreen from "./pages/cs_screen";
import LwScreen from "./pages/LwScreen";
import OnetapScreen from "./pages/OnetapScreen";
import BrSoloScreen from "./pages/BrSoloScreen";
import BrSquadScreen from "./pages/BrSquadScreen";
import EditTournament from "./pages/EditTournament";
import DeleteTournament from "./pages/DeleteTournament";
import CreateBR from "./pages/CreateBR";
import CreateBrSquad from "./pages/CreateBrSquad";
import DecideWinnerScreen from "./pages/DecideWinnerScreen";
import WagerUsers from "./pages/WagerUsers";
import TopWithdraw from "./pages/TopWithdraw";
import "./index.css";
import TopDeposit from "./pages/TopDeposit";
// 🔐 AUTH
import AdminLogin from "./auth/AdminLogin";
import AdminProtect from "./auth/AdminProtect";

// 🔥 LAYOUT
function Layout() {
  const location = useLocation();

  const isLogin = location.pathname === "/login";

  return (
    <div style={layout}>
      {/* SIDEBAR */}
      {!isLogin && <Sidebar />}

      {/* MAIN CONTENT */}
      <div
  style={{
    marginLeft: isLogin ? 0 : 230,
    width: "100%",
    minHeight: "100vh",
    padding: 20,
    background: "linear-gradient(135deg, #0F1221, #0A0D1A)",
  }}
>
  <Routes>

    <Route
      path="/login"
      element={<AdminLogin />}
    />
    <Route
  path="/top-wager"
  element={
    <AdminProtect>
      <WagerUsers />
    </AdminProtect>
  }
/>
<Route
  path="/top-deposit"
  element={
    <AdminProtect>
      <TopDeposit />
    </AdminProtect>
  }
/>
<Route
  path="/top-balance"
  element={
    <AdminProtect>
      <TopBalance />
    </AdminProtect>
  }
/>
<Route
  path="/top-withdraw"
  element={
    <AdminProtect>
      <TopWithdraw />
    </AdminProtect>
  }
/>
<Route
  path="/decide-winner"
  element={
    <AdminProtect>
      <DecideWinnerScreen />
    </AdminProtect>
  }
/>
    <Route
      path="/"
      element={
        <AdminProtect>
          <Dashboard />
        </AdminProtect>
      }
    />

    <Route
      path="/edit"
      element={
        <AdminProtect>
          <EditTournament />
        </AdminProtect>
      }
    />

    <Route
      path="/cs"
      element={
        <AdminProtect>
          <CsScreen />
        </AdminProtect>
      }
    />

    <Route
      path="/create-cs"
      element={
        <AdminProtect>
          <CreateCS />
        </AdminProtect>
      }
    />

    <Route
      path="/onetap"
      element={
        <AdminProtect>
          <OnetapScreen />
        </AdminProtect>
      }
    />

    <Route
      path="/lw"
      element={
        <AdminProtect>
          <LwScreen />
        </AdminProtect>
      }
    />

    <Route
      path="/br-solo"
      element={
        <AdminProtect>
          <BrSoloScreen />
        </AdminProtect>
      }
    />

    <Route
      path="/br-squad"
      element={
        <AdminProtect>
          <BrSquadScreen />
        </AdminProtect>
      }
    />

    <Route
      path="/today"
      element={
        <AdminProtect>
          <TodayScreen />
        </AdminProtect>
      }
    />

    <Route
      path="/deposit"
      element={
        <AdminProtect>
          <Deposit />
        </AdminProtect>
      }
    />

    <Route
      path="/users"
      element={
        <AdminProtect>
          <Users />
        </AdminProtect>
      }
    />

    <Route
      path="/tournaments"
      element={
        <AdminProtect>
          <Tournaments />
        </AdminProtect>
      }
    />

    <Route
      path="/transactions"
      element={
        <AdminProtect>
          <Transactions />
        </AdminProtect>
      }
    />
<Route
      path="/create-br-squad"
      element={
        <AdminProtect>
          <CreateBrSquad />
        </AdminProtect>
      }
    />
    <Route
      path="/create-br-solo"
      element={
        <AdminProtect>
          <CreateBR />
        </AdminProtect>
      }
    />
    <Route
      path="/withdraw"
      element={
        <AdminProtect>
          <Withdraw />
        </AdminProtect>
      }
    />
<Route
  path="/delete"
  element={
    <AdminProtect>
      <DeleteTournament />
    </AdminProtect>
  }
/>
  </Routes>
</div>
    </div>
  );
}

// 🔥 MAIN APP
function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

/* 🔥 GLOBAL LAYOUT STYLE */

const layout = {
  display: "flex",
  background: "#0F1221", // fallback
};

export default App;
